import { showErrorNotification } from '../../global/notifications';
import { isAlreadyAdded, mapCandidatesResponse, toAddedRow, toExistingRow, isDeletableInCurrentPeriod } from './manual-override';

export default function (nameAction) {
    initializeMonthPicker();

    const defaultValue = $('#month-picker-default').val();

    if (defaultValue) {
        _kendoMonthPicker.value(defaultValue);
        _month = _kendoMonthPicker.value();
        _$noMonthTopic.hide();
        _$approvalGridTopic.show();
    }

    initializeApprovalGrid();

    if (nameAction === 'approvaldetails') {
        initializedApprovalButtons();
    }
}

const urlParams = new URLSearchParams(window.location.search);
let _month = null;
let _approvalGrid = null;
const _$noMonthTopic = $('#NoMonthTopic');
const _$approvalGridTopic = $('#ApprovalGrid');
let _kendoMonthPicker = null;

function reloadGrid() {
    _$noMonthTopic.hide();
    _$approvalGridTopic.show();
    _approvalGrid.dataSource.read();
}

function initializeMonthPicker() {
    _kendoMonthPicker = $('#month-picker')
        .kendoDatePicker({
            depth: 'year',
            start: 'year',
            format: 'MMMM yyyy',
            change: onMonthChange,
        })
        .data('kendoDatePicker');

    function onMonthChange(event) {
        _month = _kendoMonthPicker.value();
        reloadGrid();
    }
}

function initializeApprovalGrid() {
    const approvalGridDataSource = new kendo.data.DataSource({
        serverFiltering: false,
        transport: {
            read: {
                type: 'get',
                url: '/Commissions/CommissionPlanApprovals/Approvals',
            },
            parameterMap(data, type) {
                if (type === 'read' && _month != null) {
                    return {
                        ...data,
                        approvalMonth: kendo.toString(_month, 'MM/01/yyyy'),
                    };
                }
                return data;
            },
        },
    });

    _approvalGrid = $('#approval-grid')
        .kendoGrid({
            dataSource: approvalGridDataSource,
            columns: [
                {
                    field: 'EmployeeName',
                    title: 'Employee Name',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                },
                {
                    field: 'EmployeeNumber',
                    title: 'Employee Number',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                },
                {
                    field: 'EmployeeRole',
                    title: 'Employee Role',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                },
                {
                    field: 'CurrentApprovalStage',
                    title: 'Approval Stage',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                },
                {
                    field: 'ApprovalStatus',
                    title: 'My Approval Status',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                    template: data => {
                        const year = _month.getFullYear();
                        const month = _month.getMonth() + 1;
                        const url = `/Commissions/CommissionPlanApprovals/ApprovalDetails?planAssignmentId=${data.PlanAssignmentId}&year=${year}&month=${month}`;
                        return `<a href="${url}" class="k-button k-primary">${data.ApprovalStatusText}</a>`;
                    },
                },
            ],
        })
        .data('kendoGrid');

    const urlYear = urlParams.get('year');
    const urlMonth = urlParams.get('month');

    if (urlYear && urlMonth && _kendoMonthPicker?.value) {
        _month = new Date(urlYear, parseInt(urlMonth, 10) - 1, 1);
        _kendoMonthPicker.value(_month);
        _kendoMonthPicker.trigger('change');
    }
}

function onSuccessfulApproval() {
    $('<div></div>').kendoAlert({
        title: 'Commission Approval Successful',
        content: 'The commission has been approved and sent for further review.',
        hide: () => onSuccessfulRequest()
    }).data('kendoAlert').open();
}

function onSuccessfulDenial(isSelf) {
    $('<div></div>').kendoAlert({
        title: 'Commission Rejection Successful',
        content: isSelf === 1 ? 'This commission rejection has been recorded and sent to the next approver.' :
            'This commission rejection has been recorded and sent back for initial review.',
        hide: () => onSuccessfulRequest()
    }).data('kendoAlert').open();
}

function onSuccessfulRecalculate() {
    $('<div></div>').kendoAlert({
        title: 'Commission Recalculation Request Successful',
        content: 'This commission is being recalculated and sent back for initial review.',
        hide: () => onSuccessfulRequest()
    }).data('kendoAlert').open();
}

function onSuccessfulRequest() {
    window.location.reload();
}

function onErrorRequest() {
    showErrorNotification('Error while sending request.');
}

function onEmptyDenial() {
    showErrorNotification('Reason for the rejection is required.');
}

function showDenialPrompt() {
    $('<div></div>').kendoPrompt({
        title: 'Commission Rejection Reason',
        content: 'Please specify the reason for the rejection',
        size: 'large'
    }).data('kendoPrompt').open().result.done(data => {
        if (!data) {
            onEmptyDenial();
            showDenialPrompt();
            return;
        }

        const planAssignmentId = urlParams.get('planAssignmentId');
        const month = urlParams.get('month');
        const year = urlParams.get('year');

        $.ajax({
            type: 'POST',
            url: `/Commissions/CommissionPlanApprovals/DenyCommission?planAssignmentId=${planAssignmentId}&month=${month}&year=${year}`,
            data: JSON.stringify({ reason: data }),
            dataType: 'json',
            contentType: 'application/json',
            success: () => onSuccessfulDenial($('#approval-deny').data('step')),
        }).fail((response) => showErrorNotification(response.responseText));
    });
}

function initProjectDataSource(projects, selectedItemsDataSource) {
    let projectFirstBind = true;

    const projectDataSource = new kendo.data.DataSource({
        data: projects.map(p => {
            return {
                ...p,
                IdDescription: `${p.ContractNumber}: ${p.ContractDescription}`,
            };
        }),
        change: () => {
            if (projectFirstBind) {
                if (window.calculatedItemsForNextMonth) {
                    for (let i in window.calculatedItemsForNextMonth) {
                        const item = window.calculatedItemsForNextMonth[i];
                        if (item.ItemType === 'project') {
                            const dataItem = projectDataSource.data().find(p => p.ContractNumber === item.ItemId);
                            if (!dataItem) continue;
                            selectedItemsDataSource.add({
                                ItemType: 'Project',
                                Id: dataItem.ContractNumber,
                                Description: dataItem.ContractDescription,
                                ProjectItem: dataItem,
                            });
                            projectDataSource.remove(dataItem);
                        }
                    }
                }

                projectFirstBind = false;
                $('#project-select')
                    .data('kendoDropDownList')
                    .value('');
            }
        },
    });

    return projectDataSource;
}

function initWorkOrderDataSource(workOrders, selectedItemsDataSource) {
    let workOrderFirstBind = true;

    const workOrderDataSource = new kendo.data.DataSource({
        data: workOrders.map(wo => {
            return {
                ...wo,
                IdDescription: `${wo.WorkOrderId}: ${wo.Description}`,
            };
        }),
        change: () => {
            if (workOrderFirstBind) {
                if (window.calculatedItemsForNextMonth) {
                    for (let i in window.calculatedItemsForNextMonth) {
                        const item = window.calculatedItemsForNextMonth[i];
                        if (item.ItemType === 'workorder') {
                            const dataItem = workOrderDataSource.data().find(wo => wo.WorkOrderId.toString() === item.ItemId);
                            if (!dataItem) continue;
                            selectedItemsDataSource.add({
                                ItemType: 'Work Order',
                                Id: dataItem.WorkOrderId,
                                Description: dataItem.Description,
                                WorkOrderItem: dataItem,
                            });
                            workOrderDataSource.remove(dataItem);
                        }
                    }
                }

                workOrderFirstBind = false;
                $('#workorder-select')
                    .data('kendoDropDownList')
                    .value('');
            }
        },
    });

    return workOrderDataSource;
}

function initProjectRecalculationSelect(selectedItemsDataSource, projectDataSource) {
    $('#project-select').kendoDropDownList({
        dataSource: projectDataSource,
        dataTextField: 'IdDescription',
        dataValueField: 'ContractNumber',
        filter: 'contains',
        optionLabel: 'Select an item',
        select: e => {
            e.preventDefault();
            var dataItem = e.dataItem;
            if (!dataItem.ContractNumber) {
                return;
            }
            projectDataSource.remove(dataItem);
            selectedItemsDataSource.add({
                ItemType: 'Project',
                Id: dataItem.ContractNumber,
                Description: dataItem.ContractDescription,
                ProjectItem: dataItem,
            });
        },
    });
}

function initWorkOrderRecalculationSelect(selectedItemsDataSource, workOrderDataSource) {
    $('#workorder-select').kendoDropDownList({
        dataSource: workOrderDataSource,
        dataTextField: 'IdDescription',
        dataValueField: 'WorkOrderId',
        filter: 'contains',
        optionLabel: 'Select an item',
        select: e => {
            e.preventDefault();
            var dataItem = e.dataItem;
            if (!dataItem.WorkOrderId) {
                return;
            }
            workOrderDataSource.remove(dataItem);
            selectedItemsDataSource.add({
                ItemType: 'Work Order',
                Id: dataItem.WorkOrderId,
                Description: dataItem.Description,
                WorkOrderItem: dataItem,
            });
        },
    });
}

function initSelectedForRecalculationGrid(selectedItemsDataSource, projectDataSource, workOrderDataSource) {
    $('#selected-items-grid').kendoGrid({
        dataSource: selectedItemsDataSource,
        dataBound: function(e) {
            const grid = e.sender;
            const items = grid.items();
            items.each((i, item) => {
                const di = grid.dataItem(item);

                $(item)
                    .find('a.delete-button')
                    .click(() => {
                        if (di.ProjectItem) {
                            projectDataSource.add(di.ProjectItem);
                        }
                        if (di.WorkOrderItem) {
                            workOrderDataSource.add(di.WorkOrderItem);
                        }
                        selectedItemsDataSource.remove(di);
                    });
            });
        },
        columns: [
            {
                title: 'Item type',
                field: 'ItemType',
            },
            {
                title: 'Id',
                field: 'Id',
            },
            {
                title: 'Description',
                field: 'Description',
            },
            {
                title: 'Remove',
                template: item => {
                    const deleteButton = '<a class="k-button delete-button"><span class="k-icon k-i-delete"></span></a>';
                    return deleteButton;
                },
            },
        ],
    });
}

function initRecalculationButton(selectedItemsDataSource) {
    $('#approval-recalculate-modal').on('click', e => {
        e.preventDefault();
        $('<div></div>')
            .kendoConfirm({
                title: 'Commission Recalculation Confirmation',
                content:
                    'Are you sure you want to recalculate the commission? ' +
                    `Recalculate will now include all selected items in the ${window.currentPeriod} Approval.`,
            })
            .data('kendoConfirm')
            .open()
            .result.done(() => {
                const planAssignmentId = urlParams.get('planAssignmentId');
                const month = urlParams.get('month');
                const year = urlParams.get('year');

                $.ajax({
                    type: 'POST',
                    contentType: 'application/json',
                    url: `/Commissions/CommissionPlanApprovals/RecalculateCommission?planAssignmentId=${planAssignmentId}&month=${month}&year=${year}`,
                    data: JSON.stringify({
                        ApprovedItems: $('#approvedCommissionItems')
                            .data('kendoGrid')
                            .dataSource.data(),
                        NextMonthItems: selectedItemsDataSource.data().map(di => {
                            return {
                                ItemId: di.Id.toString(),
                                ItemType: di.ItemType === 'Project' ? 'project' : 'workorder',
                            };
                        }),
                    }),
                    success: () => onSuccessfulRecalculate(),
                }).fail(response => showErrorNotification(response.responseText));
            });
    });
}

// --- Manual override (PBI 10542) -------------------------------------------------------------

function showManualOverrideMessage(message) {
    $('.manual-override-message')
        .text(message)
        .show();
}

function clearManualOverrideMessage() {
    $('.manual-override-message')
        .text('')
        .hide();
}

function initManualOverrideCandidateSelect(planAssignmentId, year, month) {
    const candidateDataSource = new kendo.data.DataSource({
        transport: {
            read: options => {
                $.ajax({
                    type: 'GET',
                    url:
                        '/Commissions/CommissionPlanApprovals/GetManualOverrideCandidates'
                        + `?planAssignmentId=${planAssignmentId}&employeeNumber=${window.employeeNumber}`
                        + `&year=${year}&month=${month}`,
                    success: response => {
                        const mapped = mapCandidatesResponse(response);

                        if (mapped.message) {
                            showManualOverrideMessage(mapped.message);
                        }

                        options.success(mapped.items);
                    },
                    error: () => {
                        showManualOverrideMessage('An error occurred looking up items for a manual override.');
                        options.success([]);
                    },
                });
            },
        },
    });

    return $('#manual-override-select')
        .kendoComboBox({
            dataSource: candidateDataSource,
            dataTextField: 'IdDescription',
            dataValueField: 'ItemId',
            filter: 'contains',
            minLength: 2,
            delay: 300,
            autoBind: false,
            placeholder: 'Enter a Project, Work Order, Agreement, or Change Order Number',
        })
        .data('kendoComboBox');
}

function initManualOverrideItemsGrid(addedItemsDataSource) {
    const columns = [
        {
            title: 'Item source',
            field: 'Label',
        },
        {
            title: 'Id',
            field: 'Id',
        },
        {
            title: 'Description',
            field: 'Description',
        },
    ];

    if (window.canManageManualOverrides) {
        columns.push({
            title: 'Remove',
            template: item =>
                item.Deletable
                    ? `<button type="button" class="manual-override-delete k-button k-red" ` +
                      `data-item-type="${item.ItemType}" data-item-id="${item.Id}">Remove</button>`
                    : `<span class="text-muted" title="An override can only be removed in the month it was added">-</span>`,
        });
    }

    $('#manual-override-items-grid').kendoGrid({
        dataSource: addedItemsDataSource,
        columns: columns,
    });
}

/**
 * Loads the overrides already registered for this employee so the grid shows them alongside anything
 * added in the current modal session. year/month is the period being recalculated, used to decide
 * which rows are deletable.
 */
function initManualOverrideExistingItems(employeeNumber, year, month, addedItemsDataSource) {
    $.ajax({
        type: 'GET',
        url: `/Commissions/CommissionPlanApprovals/GetManualOverrideItems?employeeNumber=${employeeNumber}`,
        success: response => {
            const items = (response && response.Items) || [];

            items
                .filter(item => isDeletableInCurrentPeriod(item, Number(year), Number(month)))
                .forEach(item => addedItemsDataSource.add(toExistingRow(item, Number(year), Number(month))));
        },
        error: () => showManualOverrideMessage('An error occurred loading existing manual overrides.'),
    });
}

function initManualOverrideDeleteHandler(planAssignmentId, year, month, addedItemsDataSource) {
    $('#manual-override-items-grid').on('click', '.manual-override-delete', e => {
        e.preventDefault();

        const $button = $(e.currentTarget);
        const itemType = $button.data('item-type');
        const itemId = $button.attr('data-item-id');

        $.ajax({
            type: 'DELETE',
            url:
                '/Commissions/CommissionPlanApprovals/RemoveManualOverrideItem'
                + `?planAssignmentId=${planAssignmentId}&employeeNumber=${window.employeeNumber}`
                + `&year=${year}&month=${month}&itemType=${itemType}&itemId=${itemId}`,
            success: () => {
                const removedRow = addedItemsDataSource
                    .data()
                    .find(row => row.ItemType === itemType && row.Id === itemId);

                if (removedRow) {
                    addedItemsDataSource.remove(removedRow);
                }

                clearManualOverrideMessage();
            },
        }).fail(response => showManualOverrideMessage(response.responseText));
    });
}

function initManualOverrideAddButton(planAssignmentId, year, month, combo, addedItemsDataSource) {
    $('#manual-override-add').on('click', e => {
        e.preventDefault();

        const candidate = combo.dataItem();

        if (!candidate || !candidate.ItemId) {
            showManualOverrideMessage('Select a Project, Work Order, Agreement, or Change Order from the list first.');
            return;
        }

        if (isAlreadyAdded(addedItemsDataSource.data(), candidate)) {
            showManualOverrideMessage('That item has already been added as a manual override.');
            return;
        }

        $.ajax({
            type: 'POST',
            contentType: 'application/json',
            url:
                '/Commissions/CommissionPlanApprovals/AddManualOverrideItem'
                + `?planAssignmentId=${planAssignmentId}&employeeNumber=${window.employeeNumber}`
                + `&year=${year}&month=${month}`,
            data: JSON.stringify({ ItemType: candidate.ItemType, ItemId: candidate.ItemId }),
            success: () => {
                addedItemsDataSource.add(toAddedRow(candidate));
                combo.value('');
                combo.dataSource.read();
                clearManualOverrideMessage();
            },
        }).fail(response => showManualOverrideMessage(response.responseText));
    });
}

function initManualOverride(planAssignmentId, year, month) {
    if ($('#manual-override-select').length === 0) {
        return;
    }

    const addedItemsDataSource = new kendo.data.DataSource({ data: [] });

    const combo = initManualOverrideCandidateSelect(planAssignmentId, year, month);

    initManualOverrideItemsGrid(addedItemsDataSource);
    initManualOverrideAddButton(planAssignmentId, year, month, combo, addedItemsDataSource);
    initManualOverrideDeleteHandler(planAssignmentId, year, month, addedItemsDataSource);
    initManualOverrideExistingItems(window.employeeNumber, year, month, addedItemsDataSource);
}

// --- End manual override ----------------------------------------------------------------------

function initRecalculationModalFromSuccessfulResponse(response) {
    $('.recalculate-modal-spinner').hide();

    if (!response.Projects || !response.WorkOrders) {
        $('.recalculate-modal-load-error').show();
        return;
    }

    try {
        const selectedItemsDataSource = new kendo.data.DataSource({
            data: [],
        });

        const projectDataSource = initProjectDataSource(response.Projects, selectedItemsDataSource);
        const workOrderDataSource = initWorkOrderDataSource(response.WorkOrders, selectedItemsDataSource);
        initProjectRecalculationSelect(selectedItemsDataSource, projectDataSource);
        initWorkOrderRecalculationSelect(selectedItemsDataSource, workOrderDataSource);
        initSelectedForRecalculationGrid(selectedItemsDataSource, projectDataSource, workOrderDataSource);
        initRecalculationButton(selectedItemsDataSource);
        $('.recalculate-modal-loaded-content').show();
        $('.recalculate-modal-loaded-enable').prop('disabled', false);
    } catch (error) {
        $('.recalculate-modal-render-error').show();
        throw error;
    }
}

function initRecalculationModalFromErrorResponse() {
    $('.recalculate-modal-spinner').hide();
    $('.recalculate-modal-load-error').show();
}

function initializedApprovalButtons() {
    $('#approval-approve').on('click', e => {
        e.preventDefault();
        $('<div></div>').kendoConfirm({
            title: 'Commission Approval Confirmation',
            content: window.approveMessage,
        }).data('kendoConfirm').open().result.done(() => {
            const planAssignmentId = urlParams.get('planAssignmentId');
            const month = urlParams.get('month');
            const year = urlParams.get('year');
            $.ajax({
                type: 'POST',
                url: `/Commissions/CommissionPlanApprovals/ApproveCommission?planAssignmentId=${planAssignmentId}&month=${month}&year=${year}`,
                data: '',
                success: () => onSuccessfulApproval(),
            }).fail((response) => showErrorNotification(response.responseText));
        });
    });

    const employeeName = $('#content').data('employeeName');

    $('#approval-deny').on('click', e => {
        e.preventDefault();
        $('<div></div>').kendoConfirm({
            title: 'Commission Rejection Confirmation',
            content: `Are you sure you want to reject the compensation plan for ${employeeName}? This action cannot be undone.`
        }).data('kendoConfirm').open().result.done(() => showDenialPrompt());
    });

    const planAssignmentId = urlParams.get('planAssignmentId');
    const month = urlParams.get('month');
    const year = urlParams.get('year');

    const recalcModal = $('#recalculate-modal')
        .kendoWindow({
            actions: ['Close'],
            title: 'Recalculation',
            visible: false,
            maxWidth: 1080,
            maxHeight: 800,
            modal: true,
            scrollable: true,
            draggable: true,
            position: {
                top: 100,
                left: 100,
            },
        })
        .data('kendoWindow');

    recalcModal.center();

    $('#approval-recalculate').on('click', e => {
        recalcModal.open();
    });

    initManualOverride(planAssignmentId, year, month);

    $.ajax({
        type: 'GET',
        url: `/Commissions/CommissionPlanApprovals/GetClosedItemsNextPeriod?planAssignmentId=${planAssignmentId}&month=${month}&year=${year}&employeeNumber=${window.employeeNumber}`,
        success: response => {
            initRecalculationModalFromSuccessfulResponse(response);
        },
        error: function(response) {
            initRecalculationModalFromErrorResponse(response);
        },
    });
}

